<template>
  <v-container justify-center fill-height>
    <v-layout row wrap style="max-width:80%;">
      <v-flex class="qr__left">
        <div class="landing-title">{{$t('web_landing_title')}}</div>
        <ol>
          <li>{{$t('web_landing_text1')}}</li>
          <li class="_1Fl07" v-html="$t('web_landing_text2')"></li>
          <li class="_1Fl07">{{$t('web_landing_text3')}}</li>
        </ol>    
      </v-flex>
      <v-flex class="qr__right">
        <qrcode-vue :value="qrdata" size="280" level="L" v-if="qrdata != ''" />
        <div style="height:280px; width:280px; background:rgba(40, 40, 40, 0.017); border-radius: 5px;" v-else>
          <v-container justify-center fill-height>
            <v-progress-circular
              :size="120"
              :width="3"
              color="grey"
              indeterminate
              
            />
          </v-container>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
  $qrwidth: 280px;
  
  .qr__right {
    width: $qrwidth; 
  }
  .qr__left {
    width: calc(100% - #{$qrwidth} - 40px); 

    .landing-title {
      color: #55636b;
      font-size: 28px;
      font-weight: 300;
      line-height: normal;
      margin-top: 0px;
      margin-bottom: 52px;
    }

    ol {
      list-style-type: decimal;

      li {
        font-size: 18px;
        line-height: 28px;        
      }
    }
  }
</style>

<script> 
  import QrcodeVue from 'qrcode.vue'
  const { detect } = require('detect-browser')

  export default {
    data () {
      return {
        token: '',
        qrdata: ''
      }
    },
    components: {
      QrcodeVue
    },
    mounted() {
      if (!window.launched) {
        this.$router.push({ name: "Loader" })
        return
      }

      const browser = detect()
      console.log('-- add-client', browser)

      this.$store.dispatch('connectWsc').then(async (nodeurl) => {

        this.token = Buffer.from('s_' + Date.now(), 'utf8').toString('hex')
        //this.token = btoa(Date.now())
        //'MTU3NjIzNTIyNTY2Mw=='
        this.qrdata = JSON.stringify({
          token: this.token,
          node: nodeurl,
          browser: browser.name,
          os: browser.os,
          pubkey: window.cryptManager.publicKey(),
        })

        this.$store.dispatch('registerWscToken', this.token).then((status) => {
          console.log('-- token registered: ' + status)
        })
      })
    }
  }
</script>